import { EditableCallbackParams, ValueSetterParams } from 'ag-grid-community';

import { EDITABLE_STATUS_KEYS } from '@/config/statuses.config';
import { UpliftData_contractLine } from './hooks/useConvertUpliftDataFormat';

export const isEditableContractLine = (params: EditableCallbackParams): boolean => {
  const contractLine: UpliftData_contractLine = params.data;
  return EDITABLE_STATUS_KEYS.includes(contractLine.status.status);
};

export const canCalculateBillingValues = (params: ValueSetterParams): boolean => {
  return params.data.billingType && (params.data.upliftValue || params.data.upliftValue === 0);
};